
webpack.register(
    'components/timeline/feed/feed',
    function() {
        return require('components/timeline/feed/feed');
    },
    false
);
webpack.register(
    'components/timeline/filter/type/type',
    function() {
        return require('components/timeline/filter/type/type');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/timeline/feed/feed'/>\r\n\r\n<div class=\"c-timeline c-timeline--{{type}}\">\r\n    <header class=\"s-header{{#if timelineTitle}} s-header--with-header{{/if}}\">\r\n        {{#if timelineTitle}}<h2 class=\"s-header-title\">{{timelineTitle}}</h2>{{/if}}\r\n        <div class=\"s-header-filters\">\r\n            <can-import from='components/timeline/filter/type/type'/>\r\n            <timeline-type-filter {active-categories}=\"activeCategories\" (filter)=\"onFilterChange(%event)\" {filters}=\"filters\"></timeline-type-filter>\r\n        </div>\r\n    </header>\r\n\r\n    <timeline-feed {cards}=\"cards\" {timeline-type}=\"type\" {(active-card)}=\"activeCard\"></timeline-feed>\r\n\r\n    {{#if loadMore}}\r\n        <footer class=\"s-timeline-footer\">\r\n            <button class=\"s-btn s-btn--more\">Load More</button>\r\n        </footer>\r\n    {{/if}}\r\n</div>\r\n");